import * as t from 'io-ts';

import {RSafetyNetBase, RSafetyNetRequiredTaggingBase, SafetyNetsEnum} from './safetyNetModel';

/*
 * Runtime types.
 */

const RConversationSafetyNetBase = t.intersection([
  RSafetyNetBase,
  t.type({
    updatedAt: t.Integer,
    isSatisfied: t.boolean,
  }),
  t.partial({
    isOptimisticallySatisfied: t.boolean,
  }),
]);

const RConversationSafetyNetRequiredTagging = t.intersection([
  RConversationSafetyNetBase,
  RSafetyNetRequiredTaggingBase,
]);

export const RConversationSafetyNet = RConversationSafetyNetRequiredTagging;

/*
 * Types.
 */

export interface ConversationSafetyNetRequiredTaggingModel
  extends t.TypeOf<typeof RConversationSafetyNetRequiredTagging> {}

export interface ConversationSafetyNetModel extends t.TypeOf<typeof RConversationSafetyNet> {}

/*
 * IO methods.
 */

export function parseConversationSafetyNet(src: any): ConversationSafetyNetModel {
  switch (src.type) {
    case SafetyNetsEnum.REQUIRED_TAGGING:
      return {
        id: src.id,
        name: src.name,
        type: src.type,
        url: src.url,
        isSatisfied: src.is_satisfied,
        isOneTagRequired: src.settings.one_tag_required,
        ownerId: src.owner_id,
        ownerType: src.owner_type,
        namespace: src.namespace,
        updatedAt: Date.now(), // TODO @required-tagging: Update this.
      };
    default:
      throw Error('Not implemented');
  }
}

/*
 * Helpers.
 */

export function isConversationSafetyNetRequiredTagging(
  safetyNet: ConversationSafetyNetModel,
): safetyNet is ConversationSafetyNetRequiredTaggingModel {
  return safetyNet.type === SafetyNetsEnum.REQUIRED_TAGGING;
}
